import React, { useContext, useState, useEffect } from "react"
import { auth } from "../firebase"

const AuthContext = React.createContext()

export function useAuth() {
  return useContext(AuthContext)
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState()
  const [loading, setLoading] = useState(true)

  function signup(email, password) {
    return auth.createUserWithEmailAndPassword(email, password)
  }

  function login(email, password) {
    // localStorage.setItem('user', email);
    return auth.signInWithEmailAndPassword(email, password)
  }

  function clearCookies() {
    // Get all cookies
    const cookies = document.cookie.split(';');
    
    // Loop through and delete each cookie
    cookies.forEach(cookie => {
        const [name] = cookie.split('=');
        document.cookie = `${name.trim()}=;domain=;path=/`;
    });
}
  function logout() {
    localStorage.clear();
    // Clear the Firebase token cookie
    document.cookie = ""
    return auth.signOut()
  }

  function resetPassword(email) {
    return auth.sendPasswordResetEmail(email)
  }

  function updateEmail(email) {
    return currentUser.updateEmail(email)
  }

  function updatePassword(password) {
    return currentUser.updatePassword(password)
  }

  useEffect(() => {

    // Function to refresh token and update cookie
    const refreshToken = async () => {
      const user = auth.currentUser;
      if (user) {
        try {
          const newToken = await auth.getIdToken(true);
          document.cookie = `token=${newToken};domain=.trackcoredata.com;path=/`;
        } catch (error) {
          console.error("Error refreshing token:", error);
        }
      } else {
        // If no user, clear the token
        document.cookie = "";
      }
    };

    refreshToken();

    const intervalId = setInterval(refreshToken, 3600000); 

    return () => {
      clearInterval(intervalId);
    };
  }, []);


  // useEffect(() => {
  //   const unsubscribe = auth.onAuthStateChanged(user => {
  //     setCurrentUser(user)
  //     setLoading(false)
  //   })

  //   return unsubscribe
  // }, [])

  
useEffect(() => {
  const unsubscribe = auth.onAuthStateChanged(user => {
    if (user) {
      setCurrentUser(user);
      localStorage.setItem('user', user.email);
    } else {
      setCurrentUser(null);
      localStorage.clear(); // 🔥 auto logout when user is deleted
    }
      setLoading(false)

  });

  return unsubscribe;
}, []);

  const value = {
    currentUser,
    login,
    signup,
    logout,
    resetPassword,
    updateEmail,
    updatePassword
  }

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  )
}
